import React from 'react';
import Tooltip from 'react-tooltip-component';
import ClampLines from 'react-clamp-lines';
class Description extends React.Component {
  shortDiscription(text) {
    if (text && text.length > 100) {
      return (
        text
          .trim()
          .substring(0, 100)
          .split(' ')
          .slice(0, -1)
          .join(' ') + '…'
      );
    } else {
      return text || '';
    }
  }

  render() {
    const shortDescription = this.shortDiscription(this.props.text);
    return (
      <Tooltip title={this.props.text} position="top">
        <div className="itemDescription">
          <ClampLines 
            text={shortDescription}
            id="clampDescription"
            lines={2}
            ellipsis="..."
            buttons={false}
            className="line-clamp"
            delay={50}
          />
        </div>
      </Tooltip>
    );
  }
}

export default Description;



// WEBPACK FOOTER //
// ./src/views/dashboard/components/items/components/Description.jsx